import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { lei } from './validator';

@Directive({
    selector: '[lei][formControlName],[lei][formControl],[lei][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => LEIValidatorDirective),
            multi: true,
        },
    ],
})
export class LEIValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = lei();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
